

<span style="filter: invert(69%) sepia(9%) saturate(2766%) hue-rotate(73deg) brightness(85%) contrast(81%)" >
    <slot />
</span>

